import { Command } from 'commander';
import { ConfigService } from '../../services/config.service.js';
import { ImageService } from '../../services/image.service.js';
import { ValidationError } from '../../errors/index.js';

export function createImageListCommand(): Command {
    return new Command('list')
        .description('List generated images')
        .option('-m, --model <model>', 'Filter by model')
        .option('-l, --limit <number>', 'Number of results', '20')
        .option('-o, --offset <number>', 'Offset for pagination', '0')
        .action(async (options) => {
            const configService = new ConfigService();
            const config = await configService.load();

            if (!config) {
                throw new ValidationError('Not initialized. Run "jai1 auth" first.');
            }

            const imageService = new ImageService();
            const result = await imageService.list(config, {
                model: options.model,
                limit: parseInt(options.limit),
                offset: parseInt(options.offset),
            });

            if (result.images.length === 0) {
                console.log('No images found.');
                return;
            }

            console.log(`\n📸 Your Generated Images (${result.total} total):\n`);

            for (const img of result.images) {
                const date = new Date(img.createdAt).toLocaleString();
                const promptPreview = img.prompt.length > 50
                    ? img.prompt.slice(0, 50) + '...'
                    : img.prompt;

                console.log(`ID: ${img.id.toString().padEnd(6)} | ${date}`);
                console.log(`   Model: ${img.model}`);
                console.log(`   Prompt: ${promptPreview}`);
                console.log(`   URL: ${img.url}`);
                console.log();
            }

            if (result.total > result.offset + result.limit) {
                const nextOffset = result.offset + result.limit;
                console.log(`💡 Show more: jai1 image list -o ${nextOffset}`);
            }
        });
}
